import Vector2 from './Vector2.js';

export default class Transform {

    constructor (
        value = new Vector2,
        velocity = new Vector2,
        acceleration = new Vector2,
        parent = null,
    ) {
        this._value = value;
        this.velocity = velocity;
        this.acceleration = acceleration;
        this.parent = parent;
    }

    get value () {
        return this.parent ? this.parent.value.add(this._value) : this._value;
    }

    get x () {
        return this.value.x;
    }

    get y () {
        return this.value.y;
    }

    get centre () {
        return this._value;
    }

    get center () {
        return this._value;
    }

    update (delta) {
        this._value = this._value.add(this.velocity.multiply(delta));
    }

    fixedUpdate () {
        this.velocity = this.velocity.add(this.acceleration);
        this.acceleration = new Vector2;
    }

    addForce (force) {
        this.acceleration = this.acceleration.add(force);
    }

    goTo (destination, speed = 0.08) {
        let desiredVelocity = destination.subtract(this._value).multiply(speed);
        this.addForce(desiredVelocity.subtract(this.velocity));
        this.fixedUpdate();
    }

}
